"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16BlobPearblob = function Svg16BlobPearblob(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M10.412 3.988c1.31-1.803 4.006-2.509 5.937-1.577 1.926.933 3.082 3.494 4.11 6.073 1.03 2.584 1.928 5.176 1.37 7.62-.554 2.44-2.566 4.727-5.043 5.546-2.472.824-5.409.174-6.737-1.743-1.332-1.916-1.055-5.11-.958-8.155.098-3.05.015-5.956 1.321-7.764z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16BlobPearblob.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16BlobPearblob;
exports.default = _default;